/** 부동산 포트폴리오 스크린샷 — public/portfolio/real-estate/ */

function realEstateSrc(filename) {
  return `/portfolio/real-estate/${encodeURIComponent(filename)}`;
}

function realEstateItem(id, title, filename, url) {
  return { id, title, url, src: realEstateSrc(filename) };
}

export const REAL_ESTATE_PORTFOLIO_IMAGES = [
  realEstateItem("dabang", "다방", "1.webp", "dabang.dsite"),
  realEstateItem("zigbang", "직방", "2.webp", "zigbang.dsite"),
  realEstateItem("the-estate", "THE ESTATE", "3.webp", "the-estate.dsite"),
  realEstateItem("mirae-realty", "미래부동산", "4.webp", "mirae-realty.dsite"),
];

export const DEFAULT_REAL_ESTATE_IMAGE = REAL_ESTATE_PORTFOLIO_IMAGES[0];
